import React, { Suspense } from "react";
import styled from "styled-components";

// import Gateway from '../components/Gateway';
// import NavBar from '../components/NavBar';
// import Logo from './../components/Logo';

const GateWay = React.lazy(() => import("../components/Gateway"));
const NavBar = React.lazy(() => import("../components/NavBar"));
const Logo = React.lazy(() => import("../components/Logo"));

const Section = styled.section`
  position: relative;
  min-height: 100vh;
  overflow: hidden;
`;

const Gateway = () => {
  return (
    <Section id="home">
      <Suspense fallback={<></>}>
        <Logo />
        <NavBar />
        <GateWay />
      </Suspense>
    </Section>
  );
};

export default Gateway;
